import React from "react";
import './FooterRoutes.css'; // Import the stylesheet

export default function ContactLensGuide() {
  return (
    <div className="container">
      <h1 className="title">Contact Lens Usage</h1>
      
      {/* Expert Consultation Section - Moved to Top */}
      <div className="section consultant-section">
        <h2 className="subtitle">
          Expert Consultation
        </h2>
        
        <div className="consultant-info">
          <div className="consultant-photo">
            <img 
              src="/contacLensOwner.jpg" 
              alt="Dhanunjay P - Consultant Optometrist"
            />
          </div>
          
          <div className="consultant-details">
  <h3 className="consultant-name">
    Dhanunjay P
  </h3>
  <p className="consultant-title">
    Consultant Optometrist
  </p>
  <p className="consultant-quote">
    "Professional guidance and personalized care for all your contact lens needs. 
    Your vision and eye health are our top priorities."
  </p>
  <p className="consultant-email mt-2 text-sm text-blue/80">
    📧 <a href="mailto:dhanuoptom@gmail.com" className="underline hover:text-blue">dhanuoptom@gmail.com</a>
  </p>
</div>

        </div>
      </div>
      
      <div className="section">
        <h2 className="subtitle">Introduction</h2>
        <p>
          Are you one of the millions who've embraced the convenience and comfort of contact lenses for clear and hassle-free vision? While contact lenses offer incredible benefits, it's crucial to prioritize eye health by taking certain precautions. In this blog post, we'll explore essential safety measures to ensure a seamless and risk-free experience with your contact lenses.
        </p>
      </div>

      <div className="section">
        <ol>
          <li>
            <p className="step-title">Cleanliness is Key:</p>
            <p>
              Maintaining proper hygiene is paramount when it comes to contact lenses. Before handling your lenses, make sure your hands are clean and dry. Avoid using moisturizing soaps or those with added fragrances, as they can leave residues on your hands that may transfer to the lenses.
            </p>
          </li>
          <li>
            <p className="step-title">Regular Lens Care:</p>
            <p>
              Always follow the recommended lens care routine provided by your eye care professional. This typically involves cleaning, disinfecting, and storing your lenses properly. Avoid taking shortcuts in your lens care routine to prevent eye infections and discomfort.
            </p>
          </li>
          <li>
            <p className="step-title">Use Recommended Solutions:</p>
            <p>
              Stick to the specific contact lens solution recommended by your eye care practitioner. Different solutions may have varying chemical compositions, and using the wrong one can lead to discomfort, irritation, or damage to the lenses.
            </p>
          </li>
          <li>
            <p className="step-title">Never Sleep in Your Lenses:</p>
            <p>
              While some contact lenses are designed for extended wear, it's crucial to follow your eye care professional's advice regarding wearing schedules. Avoid sleeping in lenses not intended for overnight use, as this can lead to reduced oxygen supply to the cornea, increasing the risk of infections.
            </p>
          </li>
          <li>
            <p className="step-title">Replace According to Schedule:</p>
            <p>
              Contact lenses have a lifespan, and it's crucial to replace them as per the recommended schedule. Overusing lenses beyond their intended duration can lead to complications, decreased vision quality, and discomfort.
            </p>
          </li>
          <li>
            <p className="step-title">Protect Your Eyes from Irritants:</p>
            <p>
              When using hairspray, applying makeup, or using other beauty products, it's wise to insert your contact lenses before these activities to prevent potential eye irritation. Additionally, try to avoid exposing your eyes to smoke or dusty environments.
            </p>
          </li>
          <li>
            <p className="step-title">Handle with Care:</p>
            <p>
              Be gentle when inserting or removing your contact lenses. Avoid using sharp objects or your fingernails, as this can damage the lenses. If you experience any difficulty handling your lenses, consult your eye care professional for guidance.
            </p>
          </li>
          <li>
            <p className="step-title">Regular Eye Check-ups:</p>
            <p>
              Schedule regular eye examinations with your eye care practitioner to ensure the health of your eyes and to receive updated prescriptions if needed. This is essential for maintaining optimal vision and preventing potential issues.
            </p>
          </li>
        </ol>
      </div>

      <div className="section">
        <p>
          Contact lenses can be a game-changer for those seeking an alternative to glasses. However, to enjoy the benefits without compromising eye health, it's crucial to follow these precautions diligently. Remember, healthy eyes contribute to clear vision and an enhanced quality of life.
        </p>
        <p>
          Prioritize your eye health, adhere to these precautions, and revel in the freedom and clarity that contact lenses bring to your everyday life. If you have any concerns or questions about contact lens usage, consult your eye care professional for personalized advice. Your eyes deserve the best care possible!
        </p>
      </div>
    </div>
  );
}
